/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import React, { useState, useRef, useCallback, useEffect } from "react";

import { Dialog, DialogContent, DialogTitle, IconButton, Paper, Typography } from "@material-ui/core";
import Axios from "axios";
import moment from 'moment';
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import Draggable from 'react-draggable';
import { useParams } from 'react-router-dom';
import Webcam from "react-webcam";

import Button from 'components/Button/button';
import CommonAlert from "components/CommonAlert/CommonAlert";
import OpenCamIcon from 'images/icons/objects/cams/camIcon.svg';
import CloseCamIcon from 'images/icons/objects/cams/camIconWhiteOutline.svg';
import SwitchCameraIcon from 'images/icons/objects/cams/switchCameraOutline.svg';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import getOptions from "services/getOptions";
import { getClientIp } from 'services/getPublicIp';
import Environment from "utils/environments";
import ValidationLength from 'utils/utils';

import NfceConfirmValues from "./NfceConfirmValues";
import UpdateNfceHeaderDialog from "./UpdateNfceHeaderDialog";
import UpdateNfceItemDialog from "./UpdateNfceItemDialog";

const environments = Environment(process.env.REACT_APP_ENV);

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-image-uploader"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} />
    </Draggable>
  );
}

function ImageUploader({
  userInfo,
  onClose,
  open,
  updateList,
  setUpdateList,
  setCropper
}) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [originalImageInfos, setOriginalImageInfos] = useState();
  const [croppedImage, setCroppedImage] = useState(null);
  const [useWebcam, setUseWebcam] = useState(true);
  const [facingMode, setFacingMode] = useState("environment");
  const [fileName, setFileName] = useState('');
  const cropperRef = useRef(null);
  const webcamRef = useRef(null);
  const { id: paramsID } = useParams();
  const [currentHeader, setCurrentHeader] = useState('');
  const [currentItem, setCurrentItem] = useState('');
  const [confirmationNfceItem, setConfirmationNfceItem] = useState('');
  const [loading, setLoading] = useState(false);
  const [publicIp, setPublicIp] = useState();
  const [totalValueConfirmation, setTotalValueConfirmation] = useState(0);
  const [unitsMeasurementsOptions, setUnitsMeasurementsOptions] = useState([]);
  const [modalSettings, setModalSettings] = useState([
    { id: 1, name: 'editHeaderDialog', open: false, fullScreen: false },
    { id: 2, name: 'editItemDialog', open: false, fullScreen: false, isNewItem: false },
  ]);
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });
  const totalItemsValue = confirmationNfceItem?.items?.reduce(
    (total, value) =>
      value?.totalValue
        ? parseFloat(total) + parseFloat(value.totalValue)
        : parseFloat(total),
    0
  );

  const isInvalidHeaderInfos = () => (
    !confirmationNfceItem?.number || 
    !confirmationNfceItem?.date ||
    (!confirmationNfceItem?.accessKey || confirmationNfceItem?.accessKey?.length !== 44) ||
    !(confirmationNfceItem?.provider?.name ||
    confirmationNfceItem?.provider?.nickname)
  )

  const hasInvalidItems = () => (
    confirmationNfceItem?.items?.some(item => !item?.description || 
      !item?.unitMeasurement || 
      !item?.code ||
      !item?.quantity ||
      !item?.unitaryValue ||
      !item?.totalValue
    )
  )

  const toggleCamera = () => {
    setFacingMode((prev) =>
      prev === "user" ? { exact: "environment" } : "user"
    );
  };

  const handleGetCnpjInfos = (currentCnpj) => {
    Axios.get(
      `${environments.workerNfce}/utils/receitaFederal/${currentCnpj}`,
    )
      .then((response) => {
        const content = response?.data?.content

        setCurrentHeader({
          ...currentHeader,
          provider: {
            ...currentHeader?.provider,
            name: content?.nickname || content?.name,
            cnpj: currentCnpj
          }
        })

        setConfirmationNfceItem({
          ...confirmationNfceItem,
          provider: {
            ...confirmationNfceItem?.provider,
            name: content?.nickname || content?.name,
            cnpj: currentCnpj
          }
        })

        setMessage({
          description: "CNPJ carregado",
          status: 'success'
        });
      })
      .catch((error) => {
        setCurrentHeader({
          ...currentHeader,
          provider: {
            ...currentHeader?.provider,
            name: ''
          }
        })

        setConfirmationNfceItem({
          ...confirmationNfceItem,
          provider: {
            ...confirmationNfceItem?.provider,
            name: '',
            cnpj: currentCnpj
          }
        })

        setMessage({
          description: "CNPJ não encontrado",
          status: 'error'
        });
      });
  }

  const handleUpdateHeader = () => {
    setConfirmationNfceItem({
      ...confirmationNfceItem,
      accessKey: currentHeader?.accessKey,
      number: currentHeader?.number,
      date: moment(currentHeader?.date)?.format('YYYY-MM-DD'),
      provider: {
        ...confirmationNfceItem?.provider,
        cnpj: currentHeader?.provider?.cnpj,
        name: currentHeader?.provider?.name,
      }
    })

    setModalSettings(
      modalSettings.map((modal) =>
        modal.name === 'editHeaderDialog' ? { ...modal, open: false } : modal
      )
    );

    setCurrentHeader('')
  }

  const addItem = () => {
    setConfirmationNfceItem({
      ...confirmationNfceItem,
      items: [
        ...confirmationNfceItem?.items,
        {
          ...currentItem,
          quantity: parseFloat(currentItem?.quantity),
          unitaryValue: parseFloat(currentItem?.unitaryValue),
          totalValue: parseFloat(currentItem?.quantity) * parseFloat(currentItem?.unitaryValue) 
        } 
      ]
    })

    setModalSettings(
      modalSettings.map((modal) =>
        modal.name === 'editItemDialog' ? { ...modal, open: false, isNewItem: false } : modal
      )
    );

    setCurrentItem('')
  }

  const removeItem = () => {
    setConfirmationNfceItem({
      ...confirmationNfceItem,
      items: confirmationNfceItem?.items?.filter(el => el?.id !== currentItem?.id)
    })

    setModalSettings(
      modalSettings.map((modal) =>
        modal.name === 'editItemDialog' ? { ...modal, open: false, isNewItem: false } : modal
      )
    );

    setCurrentItem('')
  }

  const handleUpdateItem = () => {
    setConfirmationNfceItem({
      ...confirmationNfceItem,
      items: confirmationNfceItem?.items?.map(el => {
        if (el?.id === currentItem?.id) {
          return {
            ...el,
            description: currentItem?.description,
            code: currentItem?.code,
            quantity: parseFloat(currentItem?.quantity),
            unitMeasurement: currentItem?.unitMeasurement,
            unitaryValue: parseFloat(currentItem?.unitaryValue),
            totalValue: parseFloat(currentItem?.quantity) * parseFloat(currentItem?.unitaryValue) 
          }
        }
  
        return { ...el }
      })
    })

    setModalSettings(
      modalSettings.map((modal) =>
        modal.name === 'editItemDialog' ? { ...modal, open: false, isNewItem: false } : modal
      )
    );

    setCurrentItem('')
  }

  const handleSubmitNfce = (status) => {
    const isApproveNote = status === 'approve'
    const body = {
      restaurantId: paramsID,
      user: userInfo?.user,
      approved: isApproveNote,
      traceId: confirmationNfceItem?.traceId,
      ip: publicIp,
      content: {
        ...confirmationNfceItem,
        totals: {
          ...confirmationNfceItem?.totals,
          value: totalItemsValue?.toFixed(2)
        }
      }
    }

    Axios.put(
      `${environments.workerNfce}/uploadNfce/${confirmationNfceItem?.imageId}`,
      body,
    )
      .then((response) => {
        setLoading(false);
        setMessage({
          description: `Nota ${isApproveNote ? 'baixada' : 'rejeitada'} com sucesso.`,
          status: 'success'
        });
        setSelectedImage(null)
        setCroppedImage(null)
        setFileName(null)
        setUseWebcam(!useWebcam)
        
        setTimeout(() => {
          onClose()
          setUpdateList(!updateList)
        }, 200);
      })
      .catch((error) => {
        setLoading(false);
        setMessage({
          description: error?.response?.data?.message,
          status: 'error'
        });
      });
  }

  // Upload main image
  const handleUploadMainImage = (image) => {
    setLoading(true)

    const body = {
      base64: image,
    }

    Axios.post(
      `${environments.workerNfce}/utils/calculateHash`,
      body,
    )
      .then((response) => {
        setLoading(false);
        setOriginalImageInfos({
          hash: response?.data?.hash,
          algorithm: response?.data?.algorithm,
        })
      })
      .catch((error) => {
        setLoading(false);
        setMessage({
          description: error?.response?.data?.message,
          status: 'error'
        });
      });
  };

  // Handle file selection
  const handleFileChange = (e) => {
    setCroppedImage(null);

    const file = e.target.files[0];

    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
        handleUploadMainImage(reader.result)
        setUseWebcam(false)
      };
      reader.readAsDataURL(file);
    }
  };

  // Capture photo from webcam
  const capturePhoto = useCallback(() => {
    if (webcamRef.current && webcamRef.current.video) {
      const {video} = webcamRef.current;
  
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
  
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageSrc = canvas.toDataURL('image/jpeg', 1.0);
        setSelectedImage(imageSrc);
        handleUploadMainImage(imageSrc);
        setUseWebcam(false); 
      }
    }
  }, [webcamRef]);
  

  // Upload cropped image
  const handleUpload = (image) => {
    setLoading(true)

    const body = {
      user: userInfo?.user,
      restaurantId: paramsID,
      base64: image,
      original: {
        hash: originalImageInfos?.hash,
        algorithm: originalImageInfos?.algorithm
      },
    }

    Axios.post(
      `${environments.workerNfce}/uploadNfce`,
      body,
    )
      .then((response) => {
        setLoading(false);
        setConfirmationNfceItem({
          ...response?.data?.content,
          items: response?.data?.content?.items?.filter(el => el)?.map((item, index) => (
            {
              ...item,
              id: index,
              description: item?.description === 'undefined' ? 'Item' : item?.description
            }
          )),
          traceId: response?.data?.traceId,
          imageId: response?.data?.imageId,
        })
        // handleClearFileInput(currentSkuId);
        setMessage({
          description: 'Imagem atualizada com sucesso.',
          status: 'success'
        });
      })
      .catch((error) => {
        setLoading(false);
        setMessage({
          description: error?.response?.data?.message,
          status: 'error'
        });
      });
  };
  
  // Crop the image
  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    
    if (cropper) {
      const croppedCanvas = cropper?.getCroppedCanvas({
        imageSmoothingQuality: 'high', 
      });

      setCroppedImage(croppedCanvas?.toDataURL('image/jpeg', 0.95));
      handleUpload(croppedCanvas?.toDataURL('image/jpeg', 0.95))
    }
  };

  const renderCamInfos = () => (
    <div className="imageContainer">
      <div className="imageBox">
        {!croppedImage && !selectedImage && !useWebcam &&
          <label
            className="cursorPointer"
            htmlFor="fileInput"
            style={{
              padding: "10px 20px",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          />
        }

        {croppedImage &&
          <img src={croppedImage} alt="Cropped" style={{ width: "100%" }} />
        }
        
        {useWebcam ? 
          <Webcam
            audio={false}
            ref={webcamRef}
            videoConstraints={{
              facingMode,
              width: { ideal: 1920 },
              height: { ideal: 1080 },
            }}
            screenshotFormat="image/jpeg"
            style={{ width: "100%", marginBottom: "10px" }}
          />
        : selectedImage && !croppedImage && (
          <Cropper
            style={{ height: "100%", width: '100%' }}
            preview=".img-preview"
            src={selectedImage}
            ref={cropperRef}
            viewMode={1}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive
            autoCropArea={1}
            // aspectRatio={1}
            checkOrientation={false}
            onInitialized={(instance) => {
              // setCropper(instance);
            }}
            dragMode="move"
            cropBoxMovable
            cropBoxResizable
            guides={false}
          />
        )}

        <input className="dNone" id="fileInput" type="file" accept="image/*" onChange={handleFileChange} />
      </div>

      <div className="cameraActions dFlex justifyBetween w100">
        <div 
          onClick={() => {
            toggleCamera()
          }}
          className="switchCamIconBox"
        >
          <img
            src={SwitchCameraIcon}
            alt="SwitchCameraIcon"
          />
        </div>

        {fileName ?
          <p className="mb0 mt0 pl10 pr10 textAlignCenter dFlex flexColumn justifyCenter">
            Arquivo: {ValidationLength(fileName, 20)}
          </p>
        : 
          <label
            className="cursorPointer mb0 dFlex alignCenter submitButton defaultButton"
            htmlFor="fileInput"
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
            }}
          >
            Selecionar Imagem
          </label>
        }
          
        <div 
          onClick={() => {
            setSelectedImage(null)
            setCroppedImage(null)
            setFileName(null)
            setUseWebcam(!useWebcam)
          }}
          className={`camIconBox ${useWebcam && 'active'}`}
        >
          <img
            src={useWebcam ? CloseCamIcon : OpenCamIcon}
            alt={useWebcam ? 'CloseCamIcon' : 'OpenCamIcon'}
          />
        </div>
      </div>
    </div>
  )

  const renderCamActions = () => (
    selectedImage ?
      <Button 
        onClick={() => {
          handleCrop()
        }}
        className="defaultButton submitButton ml10"
        disabled={loading}
        design="outlined"
        label={loading ? "Processando..." : "Recortar"}
      />
    :
      <Button 
        onClick={() => {
          capturePhoto()
        }}
        className="defaultButton submitButton ml10"
        design="outlined"
        label="Capturar"
        disabled={!useWebcam}
      />
  )

  const renderConfirmValueActions = () => (
    <Button 
      onClick={() => {
        handleSubmitNfce('approve')
      }}
      disabled={(!confirmationNfceItem?.provider?.name && !confirmationNfceItem?.provider?.nickname) || hasInvalidItems() || isInvalidHeaderInfos()}
      className="defaultButton submitButton ml10"
      design="outlined"
      label="Baixar"
    />
  )

  useEffect(() => {
    (async () => {
      const ip = await getClientIp();
      setPublicIp(ip);
      
      !unitsMeasurementsOptions.length &&
        getOptions(
          `${environments.catalog}/unitsMeasurements`,
          'unitsMeasurements',
          unitsMeasurementsOptions,
          setUnitsMeasurementsOptions,
          paramsID
        );
    })();
  }, [paramsID]);

  return (
    <Dialog
      open={open}
      className="defaultModal nfceImageImportDialog customZIndex"
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader bold textAlignCenter cursorMove"
        fullWidth
      >
        <Typography id="draggable-dialog-image-uploader">
          IMAGEM
        </Typography>

        <IconButton
          className="pAbsolute"
          style={{ 
            top: '14px',
            right: '10px' 
          }}
          edge="start"
          color="inherit"
          onClick={() => {
            onClose()
          }}
          aria-label="close"
        >
          <img
            style={{ width: '16px' }}
            src={CloseIconNavy}
            alt="CloseIconNavy"
          />
        </IconButton>
      </DialogTitle>

      <DialogContent className={`modalContent bgWhite dFlex justifyBetween flexColumn alignCenter ${confirmationNfceItem && 'confirmValuesContent'}`}>
        {modalSettings.find((modal) => modal.name === 'editItemDialog').open ?
          <div className="fakeBackdrop"/>
        : null}

        {confirmationNfceItem
          ? 
            <NfceConfirmValues
              modalSettings={modalSettings}
              setModalSettings={setModalSettings}
              setCurrentHeader={setCurrentHeader}
              setCurrentItem={setCurrentItem}
              confirmationNfceItem={confirmationNfceItem}
              setConfirmationNfceItem={setConfirmationNfceItem}
              totalItemsValue={totalItemsValue}
              totalValueConfirmation={totalValueConfirmation}
              setTotalValueConfirmation={setTotalValueConfirmation}
            />
          : renderCamInfos()
        }

        <div className="actionButtons dFlex justifyEnd w100 mt16">
          <Button 
            onClick={() => {
              handleSubmitNfce('reject')
            }}
            disabled={!croppedImage || !confirmationNfceItem?.imageId || hasInvalidItems() || isInvalidHeaderInfos()}
            className="defaultButton backButton"
            design="outlined"
            label="Cancelar"
          />

          {confirmationNfceItem
            ? renderConfirmValueActions()
            : renderCamActions()
          }
        </div>
      </DialogContent>

      {modalSettings.find((modal) => modal.name === 'editHeaderDialog').open && 
        <UpdateNfceHeaderDialog
          open={modalSettings.find((modal) => modal.name === 'editHeaderDialog').open}
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'editHeaderDialog' ? { ...modal, open: false } : modal
              )
            );

            setCurrentHeader('')
          }}
          confirmationNfceItem={confirmationNfceItem}
          currentHeader={currentHeader}
          setCurrentHeader={setCurrentHeader}
          handleUpdateHeader={handleUpdateHeader}
          handleGetCnpjInfos={handleGetCnpjInfos}
        />
      }
      
      {modalSettings.find((modal) => modal.name === 'editItemDialog').open && 
        <UpdateNfceItemDialog
          open={modalSettings.find((modal) => modal.name === 'editItemDialog').open}
          isNewItem={modalSettings.find((modal) => modal.name === 'editItemDialog').isNewItem}
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'editItemDialog' ? { ...modal, open: false } : modal
              )
            );

            setCurrentItem('')
          }}
          currentItem={currentItem}
          setCurrentItem={setCurrentItem}
          addItem={addItem}
          removeItem={removeItem}
          handleUpdateItem={handleUpdateItem}
          unitsMeasurementsOptions={unitsMeasurementsOptions}
        />
      }

      <CommonAlert
        customClassName="nfceSnackbarAlert"
        open={!!message.description}
        severity={message.status}
        onClose={() => {
          setMessage({ 
            ...message, 
            description: '', 
            status: '' 
          });
        }}
        messagePersonal={message.description}
        width="50%"
      />
    </Dialog>
  );
}

export default ImageUploader;